function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonsleeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 7537 7768",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1135.8,-4251.97)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4901.57,
    cy: 7854.33,
    rx: 3484.25,
    ry: 3602.36,
    style: {
      fill: "rgb(32,31,66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6259.84,11574.8C7226.37,11848.8 7864.75,11711.8 8031.5,10984.3C8597.05,11009.6 8873.72,10849.8 8503.94,10275.6C8848.09,9488.24 8646.49,9098 7913.39,9094.49C7431.1,8507.31 6869.75,8503.64 6259.84,8858.27C6230.36,8330.59 5991.52,8036.69 5433.07,8099.64C5055.26,7477.06 4564.07,7535.19 4058.91,7677.16L3070.87,7795.28C2635.49,7496.45 2381.07,7650.92 2244.09,8099.64C1691.9,7983.35 1401.85,8216.92 1417.32,8858.27L1181.1,10039.4L3307.09,10748L6259.84,11574.8Z",
    style: {
      fill: "rgb(89,101,106)",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5787.4,5787.4C3411.41,8089.32 6504.95,10873.6 7677.16,8267.72C7883.28,8695.38 7868.77,9128.78 7672.13,9566.93C7566.7,9801.84 7408.92,10038.1 7204.72,10275.6C6680.31,10661.9 6019.83,10870.3 5196.85,10866.1C4512.58,10765.8 3978.43,10581.5 3661.42,10275.6C3114.74,9739.56 2877.3,9070.79 2952.76,8267.72C2989.67,7448.57 3291.18,6772.03 3897.64,6259.84C4121.84,6066.88 4432.98,5907.91 4842.52,5787.4C5239.66,5732.13 5563.44,5726.19 5787.4,5787.4Z",
    style: {
      fill: "rgb(255,221,135)",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3543.31,9448.82C3803.28,9553.63 4000.47,9515.04 4133.86,9330.71",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "58.33px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966308,-0.25739,0.25739,0.966308,-1350,951.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3543.31,9448.82C3803.28,9553.63 4000.47,9515.04 4133.86,9330.71",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "58.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.90437,-0.42675,0.42675,0.90437,-2785.52,3074.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3659.33,9345.76C3841.32,9489.03 4000.47,9515.04 4133.86,9330.71",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "58.33px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2125.98,9685.04C2508.36,9403.75 2654.68,9580.54 2716.53,9921.26C3144.68,9817.8 3155.22,9995.46 3188.98,10157.5C3915.16,9990.86 4205.01,10158.3 4251.97,10511.8C4735.48,10188 5206.68,10355.6 5669.29,10866.1C6047.46,10788.3 6301.43,10916.4 6377.95,11338.6C6343.43,11536.8 6189.95,11657.5 5905.51,11692.9C5558.17,12096.9 5070.81,12157 4370.08,11692.9C3898.25,11793 3641.89,11610.3 3543.31,11220.5C2941.08,11670 2505.28,11522.3 2244.09,10748C1466.4,10936.2 1026.38,10723 1181.1,9803.15C1075.81,9566.74 1141.52,9300.33 1535.43,8976.38C1943.65,8926.42 2175.14,9115.75 2125.98,9685.04Z",
    style: {
      fill: "rgb(96,168,199)",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.22222,-386.125,-1679.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893.7,6496.06L3039.55,6863.32L3511.51,6863.32L3129.68,7090.29L3275.53,7457.55L2893.7,7230.57L2511.87,7457.55L2657.72,7090.29L2275.89,6863.32L2747.86,6863.32L2893.7,6496.06Z",
    style: {
      fill: "rgb(255,218,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.22222,3456.99,-1791.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893.7,6496.06L3039.55,6863.32L3511.51,6863.32L3129.68,7090.29L3275.53,7457.55L2893.7,7230.57L2511.87,7457.55L2657.72,7090.29L2275.89,6863.32L2747.86,6863.32L2893.7,6496.06Z",
    style: {
      fill: "rgb(255,218,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.884619,0,0,1,5161.36,692.058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893.7,6496.06L3039.55,6863.32L3511.51,6863.32L3129.68,7090.29L3275.53,7457.55L2893.7,7230.57L2511.87,7457.55L2657.72,7090.29L2275.89,6863.32L2747.86,6863.32L2893.7,6496.06Z",
    style: {
      fill: "rgb(255,218,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.681153,0,0,0.812158,5351.78,793.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893.7,6496.06L3039.55,6863.32L3511.51,6863.32L3129.68,7090.29L3275.53,7457.55L2893.7,7230.57L2511.87,7457.55L2657.72,7090.29L2275.89,6863.32L2747.86,6863.32L2893.7,6496.06Z",
    style: {
      fill: "rgb(255,218,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.681153,0,0,0.812158,1217.92,39.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893.7,6496.06L3039.55,6863.32L3511.51,6863.32L3129.68,7090.29L3275.53,7457.55L2893.7,7230.57L2511.87,7457.55L2657.72,7090.29L2275.89,6863.32L2747.86,6863.32L2893.7,6496.06Z",
    style: {
      fill: "rgb(255,218,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.681153,0,0,0.812158,2508.68,-469.419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893.7,6496.06L3039.55,6863.32L3511.51,6863.32L3129.68,7090.29L3275.53,7457.55L2893.7,7230.57L2511.87,7457.55L2657.72,7090.29L2275.89,6863.32L2747.86,6863.32L2893.7,6496.06Z",
    style: {
      fill: "rgb(255,218,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.482666,0,0,0.63311,4036.38,729.799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893.7,6496.06L3039.55,6863.32L3511.51,6863.32L3129.68,7090.29L3275.53,7457.55L2893.7,7230.57L2511.87,7457.55L2657.72,7090.29L2275.89,6863.32L2747.86,6863.32L2893.7,6496.06Z",
    style: {
      fill: "rgb(255,218,156)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.482666,0,0,0.63311,5099.37,3378.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893.7,6496.06L3039.55,6863.32L3511.51,6863.32L3129.68,7090.29L3275.53,7457.55L2893.7,7230.57L2511.87,7457.55L2657.72,7090.29L2275.89,6863.32L2747.86,6863.32L2893.7,6496.06Z",
    style: {
      fill: "rgb(255,218,156)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonsleeping);
export default __webpack_public_path__ + "static/media/moonsleeping.8c462c274862000acb3c6a8337130576.svg";
export { ForwardRef as ReactComponent };